import BaseService from './BaseService'

class UnauthenticatedService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  async signout(apiKey: string, refreshTokenV1: string, refreshTokenV2: string) {
    try {
      await this.noJWTInstance.post('/auth/signout', {}, {
        headers: {
          ...this.headers,
          authorization: `Bearer ${apiKey}`,
          'refresh-token-v1': refreshTokenV1,
          'refresh-token-v2': refreshTokenV2,
        },
      })
    } catch (error) {
      console.error('Error signing out from unauthenticated service', error)
    }
  }

  async loginWithToken(params: any) {
    try {
      return await this.noJWTInstance.post('/auth/login/token', params, {
        headers: {
          ...this.headers,
          'source': 'WEB_USER',
          'channel': 'APP'
        },
      })
    } catch (error) {
      console.error('Error signing in with token', error)
      throw error
    }
  }
}

const instance = new UnauthenticatedService(BaseService.servicesConfig.Oauth || '')

export default instance 